import React, { useEffect, useRef, useState } from 'react';
import { useDialogFocus } from './Help/useDialogFocus';
import './ConfirmDialog.css';
interface Options { title: string; message?: string; inputLabel?: string; required?: boolean; confirmLabel?: string; }
/** Shared confirmation and optional-notes modal, including WRMP void reasons. */
export function ConfirmDialog({ title, message, inputLabel, required, confirmLabel = 'Confirm', onClose }: Options & { onClose: (value: string | null) => void }) {
  const [value, setValue] = useState('');
  const ref = useRef<HTMLDivElement>(null);
  useDialogFocus(ref);
  useEffect(() => { const key = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(null); }; document.addEventListener('keydown', key); return () => document.removeEventListener('keydown', key); }, [onClose]);
  return <div className="confirmation-overlay"><div ref={ref} tabIndex={-1} className="confirmation-card" role="dialog" aria-modal="true" aria-label={title}>
    <h2>{title}</h2>{message && <p>{message}</p>}
    {inputLabel && <label>{inputLabel}<textarea autoFocus value={value} onChange={e => setValue(e.target.value)} /></label>}
    <div className="confirmation-buttons"><button className="btn btn-secondary" onClick={() => onClose(null)}>Cancel</button><button className="btn btn-primary" disabled={required && !value.trim()} onClick={() => onClose(value.trim())}>{confirmLabel}</button></div>
  </div></div>;
}
/** Await an explicit choice; cancelling never performs the operation. */
export function useConfirmation() {
  const [pending, setPending] = useState<{ options: Options; resolve: (value: string | null) => void } | null>(null);
  const ask = (options: Options) => new Promise<string | null>(resolve => setPending({ options, resolve }));
  const confirm = async (message: string) => (await ask({ title: 'Confirm action', message })) !== null;
  const dialog = pending ? <ConfirmDialog {...pending.options} onClose={value => { pending.resolve(value); setPending(null); }} /> : null;
  return { ask, confirm, dialog };
}
